import { render } from "./FeaturedDisplay.vue?vue&type=template&id=4fe290d2&scoped=true"
import script from "./FeaturedDisplay.vue?vue&type=script&lang=js"
export * from "./FeaturedDisplay.vue?vue&type=script&lang=js"

import "./FeaturedDisplay.vue?vue&type=style&index=0&id=4fe290d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe290d2"]])

export default __exports__